// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"goToFAQ-module--wrapper--3SV4E","icon":"goToFAQ-module--icon--atcqR","content":"goToFAQ-module--content--1jCLI"};